export const mayAbbreviatedLowercase = "Wqa";
export default {mayAbbreviatedLowercase};